import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useQuestionTypes = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['question-types'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/cms/question-types`});
      return result;
    },
    staleTime: 0, 
    cacheTime: 0
  });
};
